<template>
    <div class="pci-row">
        <div class="pci-drag" title="Sürükle">≡</div>
        <div
            v-tippy="{
                followCursor: true,
                placement: 'right',
                theme: isDarkMode ? 'light-border' : 'google',
            }"
            :content="getContentName(child, 'content')"
            class="pci-main"
        >
            <div class="pci-shortcut">
                <span v-if="child.type === 'ALT'" class="pci-badge">
                    {{ isMac ? "⌃" : "Alt" }}+{{ child.letter }}
                </span>
                <span v-else-if="child.type === 'TAB'" class="pci-badge">
                    {{ child.letter }} → Tab → {{ child.number }}
                </span>
                <span v-else-if="child.type === 'HASH'" class="pci-badge">#{{ child.hash }}</span>
            </div>
            <div class="pci-title">{{ getContentName(child) }}</div>
        </div>
        <div class="pci-actions">
            <SupsisButton icon square xsmall v-tippy="{ content: $t('message.edit') }" @click="$emit('edit', child._id, true)">
                <md-icon>edit</md-icon>
            </SupsisButton>
            <SupsisButton
                v-if="canDelete"
                icon
                square
                xsmall
                classNames="pci-delete-btn"
                v-tippy="{ content: $t('message.deleteField') }"
                @click="$emit('remove', child._id)"
            >
                <md-icon>delete</md-icon>
            </SupsisButton>
        </div>
    </div>
</template>

<script>
import SupsisButton from "../../../components/SupsisButton.vue";

export default {
    name: "PreparedContentsItemRow",
    components: {
        SupsisButton,
    },
    props: {
        child: { type: Object, required: true },
        isMac: Boolean,
        isDarkMode: Boolean,
        canDelete: Boolean,
        getContentName: { type: Function, required: true },
    },
};
</script>

<style lang="scss" scoped>
.pci-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid var(--color-border-default);
    background: #ffffff;
    transition: all 0.2s;

    &:hover {
        border-color: #22272d;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }
}

.pci-drag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    cursor: grab;
    user-select: none;
    font-size: 14px;
    line-height: 1;
    color: var(--color-text-subtle);
    background: var(--color-bg-ghost-default);
    border: 1px solid var(--color-border-default);
    border-radius: 4px;
    transition: all 0.2s;

    &:hover {
        color: var(--color-text-strong-default);
        border-color: #22272d;
        background: #ffffff;
    }

    &:active {
        cursor: grabbing;
        transform: scale(0.95);
    }
}

.pci-main {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    min-width: 0;
    cursor: help;
}

.pci-shortcut {
    flex: none;
}

.pci-badge {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 4px 8px;
    border-radius: 6px;
    background: #EEE7FF;
    border: 1px solid #5625CC;
    color: #5625CC;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
}

.pci-title {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--color-text-strong-default);
    font-size: 13px;
    font-weight: 600;
}

.pci-actions {
    display: flex;
    align-items: center;
    gap: 4px;
    opacity: 0;
    transition: opacity 0.2s;

    .pci-row:hover & {
        opacity: 1;
    }

    ::v-deep .pci-delete-btn {
        border: none !important;
        background: transparent !important;
        color: #ef4444 !important;

        &:hover {
            background: rgba(239, 68, 68, 0.1) !important;
        }
    }
}
</style>
